import React from "react";
import { useTranslation } from "react-i18next";
import Input from "components/form/input/Input";
import { useColorPickerController } from "../useColorPickerController";
import { HueSpectrum } from "./canvas/HueSpectrum";
import { SaturationBrightnessPanel } from "./canvas/SaturationBrightnessPanel";

interface IColorPickerContentProps {
  hexColor: string;
  updateHexColor: (updatedHexColor: string | null) => void;
  className?: string;
  onGestureStart?: () => void;
  onGestureEnd?: () => void;
}

export function ColorPickerContent(props: IColorPickerContentProps) {
  const { hexColor, updateHexColor, className, onGestureStart, onGestureEnd } = props;
  const { t } = useTranslation();
  const colorPickerController = useColorPickerController(hexColor, updateHexColor);

  return (
    <div className={className ?? "color-picker-controls"}>
      <SaturationBrightnessPanel
        rgb={colorPickerController.rgb}
        hsv={colorPickerController.hsv}
        dispatchUpdateHsv={colorPickerController.dispatchUpdateHsv}
        onGestureStart={onGestureStart}
        onGestureEnd={onGestureEnd}
      />
      <HueSpectrum
        hsv={colorPickerController.hsv}
        dispatchUpdateHsv={colorPickerController.dispatchUpdateHsv}
        onGestureStart={onGestureStart}
        onGestureEnd={onGestureEnd}
      />
      <div className="color-picker-controls-inputs">
        <Input
          className="color-picker-controls-hex-color-input"
          label={t("Hex")}
          value={colorPickerController.hexColorInput}
          onChange={e => colorPickerController.dispatchUpdateHexColorInput(e.target.value)}
          onFocus={onGestureStart}
          onBlur={onGestureEnd}
        />
        <Input
          label={"R"}
          value={colorPickerController.rgbInput.r}
          onChange={e => colorPickerController.dispatchUpdateRgbInput("r", e.target.value)}
          onFocus={onGestureStart}
          onBlur={onGestureEnd}
        />
        <Input
          label={"G"}
          value={colorPickerController.rgbInput.g}
          onChange={e => colorPickerController.dispatchUpdateRgbInput("g", e.target.value)}
          onFocus={onGestureStart}
          onBlur={onGestureEnd}
        />
        <Input
          label={"B"}
          value={colorPickerController.rgbInput.b}
          onChange={e => colorPickerController.dispatchUpdateRgbInput("b", e.target.value)}
          onFocus={onGestureStart}
          onBlur={onGestureEnd}
        />
      </div>
    </div>
  );
}
